import React, { useState } from "react"
import { Image, Box, Heading } from "rebass"
import { keyframes } from "@emotion/core"
import styled from "@emotion/styled"

import ButtonsNav from "./ButtonsNav"

const Card = props => {
  const { data, index } = props
  const { title, text, image, video, buttonsButtons, imageSuperTag } = data
  const [hover, setHover] = useState(false)

  return (
    <Box
      as="aside"
      onMouseEnter={e => setHover(true)}
      onMouseLeave={e => setHover(false)}
    >
      {image && (
        <Box as={Figure} mb={["10px", null, 3]}>
          {imageSuperTag && (
            <Box
              as="figcaption"
              className={index % 2 ? `variation-a` : `variation-b`}
              fontSize={[0]}
              size={["88px", null, "110px"]}
            >
              <span>{imageSuperTag}</span>
            </Box>
          )}
          {video && hover && (
            <Box
              as={`video`}
              playsInline
              muted
              loop
              autoPlay
              disableremoteplayback="true"
            >
              <source src={video.mediaItemUrl} />
            </Box>
          )}
          <Box as="picture">
            <Image srcSet={image.srcSet} alt={image.title} />
          </Box>
        </Box>
      )}
      <Box as={Footer} px={["20px", null, 4, "74px"]} py={["24px", null, 5]}>
        <Heading as="h3" mb="1em" color="primary" fontSize={[2, null, 3]}>
          {title}
        </Heading>
        <Box as="p" fontSize={[1]} dangerouslySetInnerHTML={{ __html: text }} />
        {buttonsButtons && (
          <ButtonsNav data={buttonsButtons} pt={[3, null, 4]} />
        )}
      </Box>
    </Box>
  )
}

export default Card

// component styles

const fadeIn = keyframes`
  to {
    opacity: 100%;
  }
`

const Figure = styled.figure`
  position: relative;

  figcaption {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    font-family: ${props => props.theme.fonts.heading};
    &.variation-a {
      color: ${props => props.theme.colors.primary};
      background: ${props => props.theme.colors.secondary};
    }
    &.variation-b {
      color: ${props => props.theme.colors.secondary};
      background: ${props => props.theme.colors.primary};
      border-radius: ${props => props.theme.radii.circle};
    }
  }

  picture {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    img {
      object-fit: cover;
      object-position: center center;
      height: 100%;
      width: 100%;
    }
  }

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 2;
    opacity: 0;
  }

  &:after {
    content: "";
    display: inline-block;
    padding-top: 72%;
  }

  &:hover {
    video {
      animation-name: ${fadeIn};
      animation-fill-mode: both;
      animation-duration: 0.75s;
    }
  }
`

const Footer = styled.footer`
  border: 1px solid ${props => props.theme.colors.gray};
  border-radius: ${props => props.theme.radii.default}px;
`
